module.exports = __webpack_public_path__ + "img/header-engagementRingsSolitaire.38d3cd7.jpg";